/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */

const Home = () => import('@/views/Home')
const Callback = () => import('@/views/Callback')
const Complaint = () => import('@/views/Complaint')
const ComplaintReportInternal = () => import('@/views/ComplaintInternal')
const ComplaintSearch = () => import('@/views/ComplaintSearch')
const Dashboard = () => import('@/views/Dashboard')
const IncidentReport = () => import('@/views/IncidentReport')
const IncidentReportInternal = () => import('@/views/IncidentReportInternal')
const IncidentSearch = () => import('@/views/IncidentSearch')
const UserProfile = () => import('@/views/UserProfile')
const UserAdministration = () => import('@/views/UserAdministration')
const Reports = () => import('@/views/Reports')
const InternalReports = () => import('@/views/InternalReports')
const EmailTemplates = () => import('@/views/EmailTemplates')
const TestMisc = () => import('@/views/TestMisc')
const HCBReport = () => import('@/views/HCBReport')
const HCBReportSearch = () => import('@/views/HCBReportSearch')
const HCBReportInternal = () => import('@/views/HCBReportInternal')

export default [
    {
        path: '/:pathMatch(.*)*',
        redirect: '/home'
    },
    {
        path: '/home',
        component: Home,
        name: 'home',
        meta: {
            title: 'Home'
        }
    },
    {
        path: '/incident-report',
        component: IncidentReport,
        name: 'incidentReport',
        meta: {
            title: 'Report a Spill or Release'
        }
    },
    {
        path: '/complaint',
        component: Complaint,
        name: 'complaint',
        meta: {
            title: 'Submit a Complaint'
        }
    },
    {
        path: '/reports',
        component: Reports,
        name: 'reports',
        meta: {
            title: 'Reports'
        }
    },
    {
        path: '/user-profile',
        component: UserProfile,
        name: 'userProfile',
        meta: {
            title: 'User Profile'
        }
    },
    {
        path: '/callback',
        component: Callback,
        name: 'Callback'
    },
    {
        path: '/dashboard',
        component: Dashboard,
        name: 'dashboard',
        meta: {
            requiresAuth: true,
            title: 'Dashboard'
        }
    },
    {
        path: '/incident-search',
        component: IncidentSearch,
        name: 'incidentsearch',
        meta: {
            requiresAuth: true,
            title: 'Incident Search'
        }
    },
    {
        path: '/incident-internal/:incidentReportId?',
        component: IncidentReportInternal,
        name: 'incidentinternal',
        meta: {
            requiresAuth: true,
            title: 'Incident Report'
        }
    },
    {
        path: '/complaint-internal/:complaintId?',
        component: ComplaintReportInternal,
        name: 'complaintInternal',
        meta: {
            requiresAuth: true,
            title: 'Complaint'
        }
    },
    {
        path: '/complaint-search',
        component: ComplaintSearch,
        name: 'complaintsearch',
        meta: {
            requiresAuth: true,
            title: 'Complaint Search'
        }
    },
    {
        path: '/user-administration',
        component: UserAdministration,
        name: 'useradministration',
        meta: {
            requiresAuth: true,
            requiresAdmin: true,
            title: 'User Administration'
        }
    },
    {
        path: '/internal-reports',
        component: InternalReports,
        name: 'internalreports',
        meta: {
            requiresAuth: true,
            title: 'Internal Reports'
        }
    },
    {
        path: '/email-templates',
        component: EmailTemplates,
        name: 'emailtemplates',
        meta: {
            requiresAuth: true,
            title: 'Email Templates'
        }
    },
    {
        path: '/email-templates/test-misc',
        component: TestMisc,
        name: 'testmisc',
        meta: {
            requiresAuth: true,
            title: 'Test Misc'
        }
    },
    {
        path: '/hcb-report',
        component: HCBReport,
        name: 'hcbReport',
        meta: {
            requiresAuth: false,
            title: 'Report a Bloom'
        }
    },
    {
        path: '/hcb-search',
        component: HCBReportSearch,
        name: 'hcbSearch',
        meta: {
            requiresAuth: true,
            title: 'Bloom Search'
        }
    },
    {
        path: '/hcb-internal/:hcbReportId?',
        component: HCBReportInternal,
        name: 'hcbInternal',
        meta: {
            requiresAuth: true,
            title: 'Bloom Report'
        }
    }
]
